import {
    FETCH_REQUEST, FetchRequestAction
} from './fetch-middleware.types';

export const createFetchAction = (payload: FetchRequestAction['payload']): FetchRequestAction => {
    return {
        type: FETCH_REQUEST,
        payload
    };
};
